<template>
    <div>
        <page-header :btnNew="this.$hasPermission('PropertiesType_create') ? 'ACTIONS.NEW' : null" pageTitle="PROPERTY_TYPES.INDEX_TITLE"
                     :haveSearch="true"
                     @searching="search($event)"
                     @newType="setRegisterModal"/>

        <div class="mb-3 text-right" v-if="isUserR2()">
            <button
                data-cy="sync-property-types"
                class="btn btn-warning"
                data-toggle="modal"
                data-target="#customModalTwo"
                @click="prepSyncModal">
                <i class="icon-sync mr-1"></i>{{ t('ACTIONS.SYNC') }}
            </button>
        </div>

        <list-component :items="items.data" v-if="items && items.data" :haveDetails="false">
            <template v-slot:principal-info="{items}">
                <div class="list-primary hide-text">{{ items.iten.name }}</div>
            </template>
            <template v-slot:dropdown-options="items">
                <div class="dropdown-item pointer text-white" data-target="#customModalTwo" data-toggle="modal"
                     data-cy="edit-property-type"
                     @click="setEditModal(items.iten)" v-if="this.$hasPermission('PropertiesType_update')">
                    <i class="icon-edit mr-2 font-15"/>{{ t('ACTIONS.EDIT') }}
                </div>
                <div class="dropdown-item pointer text-white" data-cy="delete-property-type"
                     @click="showAlert(items.iten.id)" v-if="this.$hasPermission('PropertiesType_delete')">
                    <i class="icon-delete mr-2 font-15"/>{{ t('ACTIONS.DELETE') }}
                </div>
            </template>
        </list-component>

        <pagination-component v-if="items && items.data" :items="items" :to="'/tipo-propriedade'"
                              @changePage="index(filter, $event)"></pagination-component>

        <div class="card" v-if="items && !items.data">
            <div class="card-header"></div>
            <div class="card-body pt-0">
                <div class="text-center">
                    <h5>{{ t('GENERAL.MSG.NO_REGISTER', {name: t('PROPERTY_TYPES.PROPERTIES_TYPES'), os: 'os'}) }}</h5>
                </div>
            </div>
        </div>

        <modal :titleModal="modalTitle">
            <template v-slot:title>{{ t(modalTitle) }}</template>

            <div class="modal-body" v-if="isSyncFlow">
                <p class="mb-2">{{ t('PROPERTY_TYPES.SYNC.CONFIRM_MSG') }}</p>
                <ul class="sync-list">
                    <li>{{ t('PROPERTY_TYPES.SYNC.CHECK_DUPLICATES') }}</li>
                    <li>{{ t('PROPERTY_TYPES.SYNC.CHECK_RULES') }}</li>
                    <li>{{ t('PROPERTY_TYPES.SYNC.CHECK_INTEGRATIONS') }}</li>
                </ul>
            </div>
            <div class="modal-footer2" v-if="isSyncFlow">
                <button class="btn btn-secondary" data-dismiss="modal" type="button" :disabled="isSyncing">
                    {{ t('ACTIONS.CANCEL') }}
                </button>
                <button
                    data-cy="confirm-sync-property-types"
                    class="btn btn-primary ml-2"
                    type="button"
                    @click="confirmSync"
                    :disabled="isSyncing"
                >
                    <span v-if="!isSyncing">{{ t('ACTIONS.CONFIRM') }}</span>
                    <span v-else><i class="icon-autorenew mr-1 spin"></i>{{ t('GENERAL.MSG.PROCESSING') }}</span>
                </button>
            </div>

            <form v-else @submit.prevent="create">
                <div class="modal-body">
                    <ModalBodySectionComponent
                            eyebrow="Tipo de lotes"
                            :title="t(modalTitle)"
                            icon="icon-plus"></ModalBodySectionComponent>
                    <div class="form-group">
                        <label for="inputName" class="required">{{ t('GENERAL.NAME') }}: </label>
                        <input id="name" v-model="name" class="form-control" name="name" placeholder="Digite o nome"
                               type="text" @keyup="inputName(name)">
                        <div v-if="isNameInvalid" class="validation">{{ t(msgError) }}</div>
                    </div>
                </div>
                <div class="modal-footer2">
                    <div class="justify-content-left">
                        <h5 class="ml-2" style="color: red; font-size: .7rem;">{{ t('GENERAL.REQUIRED_FIELDS') }} *</h5>
                    </div>
                    <div class="ml-custom">
                        <button data-cy="property_type_create_close" class="btn btn-secondary" data-dismiss="modal"
                                type="button">
                            {{ t('ACTIONS.CLOSE') }}
                        </button>
                        <button data-cy="property_type_create_save" class="btn btn-primary ml-2" type="submit">
                            {{ t('ACTIONS.SAVE') }}
                        </button>
                    </div>
                </div>
            </form>
        </modal>
    </div>
</template>

<script>

import jwt_decode from "jwt-decode";
import {useI18n} from "vue-i18n";
import {defineComponent} from 'vue';
import Modal from "@/components/modal";
import {useToast} from "vue-toastification";
import Validate from '@/components/validate.vue';
import propertyTypes from '@/services/propertyTypes';
import pageHeader from "@/components/layouts/pageHeader";
import ListComponent from '@/components/layouts/listComponent.vue';
import PaginationComponent from "@/components/layouts/PaginationComponent";
import ModalBodySectionComponent from '../../components/layouts/ModalBodySectionComponent';

export default defineComponent({
    name: 'indexPropertyTypes',
    mixins: [Validate],
    components: {
        Modal,
        pageHeader,
        ListComponent,
        PaginationComponent,
        ModalBodySectionComponent,
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            isSyncing: false,
            isSyncFlow: false,
            msg: '',
            id: null,
            type: {},
            resp: null,
            items: null,
            filter: null,
            modalTitle: '',
        }
    },
    mounted() {
        this.$canAccess('PropertiesType_index');
        this.$store.commit('changeLoading', true);
        this.index();
    },
    methods: {
        isUserR2() {
            try {
                const raw = localStorage.getItem('access_token');
                if (!raw) return false;
                const token = jwt_decode(raw);
                return typeof token?.login === 'string' && token.login.endsWith('@r2soft.com.br');
            } catch {
                return false;
            }
        },

        prepSyncModal() {
            this.isSyncFlow = true;
            this.modalTitle = 'PROPERTY_TYPES.SYNC.TITLE';
        },

        async confirmSync() {
            this.isSyncing = true;
            this.$store.commit('changeLoading', true);
            try {
                await propertyTypes.synchronize();
                this.toast.success(this.t('PROPERTY_TYPES.SYNC.SUCCESS'));
                document.getElementById('closeX')?.click();
                await this.index();
            } catch (error) {
                this.errorMsg(error);
            } finally {
                this.isSyncing = false;
                this.$store.commit('changeLoading', false);
            }
        },

        search(filter) {
            this.filter = {filtro: filter};
            this.index(this.filter, 1);
        },

        async index(filter = null, page = 1) {
            await propertyTypes.index(filter, page).then(resp => {
                this.items = resp.data;
            }).catch(error => {
                this.errorMsg(error)
            });
            this.$store.commit('changeLoading', false);
        },

        updatePaginate(page) {
            this.updateItemsFromPaginate(page, propertyTypes)
        },

        setEditModal(iten) {
            this.isSyncFlow = false;
            this.id = iten.id;
            this.name = iten.name;
            this.modalTitle = 'PROPERTY_TYPES.MODAL_TITLE.EDIT';
        },

        setRegisterModal() {
            this.isSyncFlow = false;
            this.id = null;
            this.name = null
            this.modalTitle = 'PROPERTY_TYPES.MODAL_TITLE.ADD';
        },

        showAlert(id) {
            this.$swal.fire({
                title: this.t('GENERAL.MSG.REALLY_WANT_DELETE'),

                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: `Excluir`,
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);

                    propertyTypes.delete(id).then(resp => {
                        document.getElementById('closeX').click();
                        this.resp = resp;
                        this.index();
                        this.$store.commit('changeLoading', false);
                        this.toast.success(resp.data.validations.message);

                    }).catch(error => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(error)
                    });
                }
            });
        },

        create() {
            this.startForm();

            if (this.checkForm()) {
                this.$store.commit('changeLoading', true);

                if (this.type.id) {

                    propertyTypes.update(this.type).then(resp => {
                        document.getElementById('closeX').click();
                        this.resp = resp;
                        this.index();
                        this.$store.commit('changeLoading', false);
                        this.toast.success(this.t('GENERAL.MSG.UPDATE_SUCCESS'));

                    }).catch(error => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(error);
                    });

                } else {

                    propertyTypes.create(this.type).then(resp => {
                        document.getElementById('closeX').click();
                        this.resp = resp;
                        this.index();
                        this.$store.commit('changeLoading', false);
                        this.toast.success(this.t('GENERAL.MSG.REGISTER_SUCCESS'));

                    }).catch(error => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(error);
                    });
                }
            }
        },

        checkForm() {
            this.nameValidate(this.name);

            if (this.invalid.length && this.invalid.length > 0) {
                return false;
            }
            return true;
        },


        startForm() {
            this.type = {
                id: this.id,
                name: this.name,
            }
            this.invalid = [];
        }
    }
});
</script>

<style>
.zIndex {
    z-index: 100000000000 !important;
}

.spin {
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.sync-list {
    list-style-type: disc;
    margin-left: 1.5rem;
    padding-left: 0.5rem;
}

.sync-list li {
    margin-bottom: 0.4rem;
    line-height: 1.4;
}
</style>
